import { BACKEND_URL } from 'config/constants'

export default () => ({
  appi: {
    type: 'vector',
    tiles: [`${BACKEND_URL}/map/logement/_location/{z}/{x}/{y}`],
    maxzoom: 11,
  },
  elastic: {
    type: 'vector',
    maxzoom: 14,
    tiles: [
      // 'https://tiles.maps.elastic.co/data/v3/{z}/{x}/{y}.pbf?elastic_tile_service_tos=agree&my_app_name=kibana&my_app_version=7.16.2&license=017f70ce-abfc-4439-a530-4b6e1c60b42b',
      'https://api.maptiler.com/tiles/v3/{z}/{x}/{y}.pbf?key=Ky5U0VOne5HZV77g4EvL', // TODO ApiKey à gérer par le back ?
    ],
  },
})
